import React, { lazy, Suspense } from 'react';

const LazyQuanLyTaiKhoan = lazy(() => import('./QuanLyTaiKhoan'));

const QuanLyTaiKhoan = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyQuanLyTaiKhoan {...props} />
  </Suspense>
);

export default QuanLyTaiKhoan;
